<template>
	<div v-if="!printMode && reports && Object.keys(reports).length > 1"
		 class="ui center aligned container swap-buttons">
		<div class="ui basic icon buttons">
			<button :class="['ui', { disabled: currentReportIndex === 0 } ,'button']" @click.prevent="swapToLeft()">
				<i :class="['chevron', 'left', { grey: currentReportIndex === 0 }, 'icon']"></i>
			</button>
			<button :class="['ui', { disabled: currentReportIndex === dataSource.length - 1 } ,'button']"
					@click.prevent="swapToRight()">
				<i :class="['chevron', 'right', { grey: currentReportIndex === dataSource.length - 1 }, 'icon']"></i>
			</button>
		</div>
	</div>
</template>

<script>
  import {reportStatus} from '@/modules/neodash/enuns/report.enum';
  import {PRINT_GET_PRINT_MODE} from '@/store/modules/print/types';
  import {REPORT_GET_REPORTS} from '@/modules/neodash/store/modules/report/types';
  import _ from 'lodash';
  import {mapGetters} from 'vuex';

  export default {
    props: {
      dataSource: {
        type: Array,
        required: true
      },

      name: {
        type: String,
        required: true
      }
    },

    computed: {
      ...mapGetters({
        reports: REPORT_GET_REPORTS,
        printMode: PRINT_GET_PRINT_MODE
      }),

      currentReportIndex() {
        return _.findIndex(this.dataSource, d => d.value === this.name);
      }
    },

    data() {
      return {
        reportName: this.$route.params.reportName,
        subReportName: this.$route.params.subReportName
      };
    },

    methods: {
      swapToLeft() {
        if (this.currentReportIndex !== 0) {
          this.changeRoute(this.dataSource[this.currentReportIndex - 1].value);
        }
      },

      swapToRight() {
        if (this.currentReportIndex < this.dataSource.length) {
          this.changeRoute(this.dataSource[this.currentReportIndex + 1].value);
        }
      },

      changeRoute(path) {
        this.$router.push({
          name: 'report-page',
          params: {
            reportName: this.reportName,
            subReportName: path
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
	.ui.swap-buttons {
		position: absolute;
		bottom: 1rem;
		left: 0;
		right: 0;
		z-index: 1;

		.ui.buttons {
			border-radius: 0.28571429rem;
			background-color: #FFFFFF;
			box-shadow: inset 0 1px 0 hsla(0, 0%, 100%, .2), 0 1px 2px rgba(0, 0, 0, .05) !important;
		}
	}
</style>
